const constants = Object.freeze({
  MOBILE_BREAKPOINT: 768,
  MOBILE_NAVBAR_HEIGHT: 64,
});

export default constants;
